export default __webpack_public_path__ + "static/media/Finalizar_OCD.9216bce6.svg";